export default __webpack_public_path__ + "ee960c34a14c142d98702e2659e22f20.png";